// eslint-disable-next-line no-unused-vars
import type {GatsbyBrowser} from 'gatsby';
import {Helmet} from 'react-helmet';
import './src/assets/styles/core.css';
import {ApolloProvider} from '@apollo/client/react';
import {ToastContainer} from 'react-toastify';
import graphQLClient from './src/helpers/graphql/client';
import logPageview from './src/helpers/analytics/logPageview';
import UserSettingsProvider from './src/components/providers/UserSettingsProvider';
import ScreenshotProvider from './src/components/providers/ScreenshotProvider';
import FeedbackContainer from './src/components/layout/feedbackContainer/feedbackContainer';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => logPageview(location.pathname);

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({element}) => (
    <UserSettingsProvider>
        <ApolloProvider client={graphQLClient}>
            <Helmet>
                <meta name="theme-color" content="#ffffff" />
                <link rel="icon" href="/favicon.ico" sizes="32x32" />
                <link rel="icon" type="image/png" sizes="32x32" href="/images/favicons/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/images/favicons/favicon-16x16.png" />
                <link rel="icon" type="image/svg+xml" href="/images/favicons/favicon.svg" />
                <link rel="apple-touch-icon" sizes="180x180" href="/images/favicons/apple-touch-icon.png" />
                <link rel="mask-icon" href="/images/favicons/favicon.svg" color="#e3000b" />
                <link rel="manifest" href="/images/favicons/manifest.json" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
            </Helmet>
            <ScreenshotProvider>
                {element}
                <ToastContainer
                    position="top-right"
                    autoClose={15000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                />
                <FeedbackContainer />
            </ScreenshotProvider>
        </ApolloProvider>
    </UserSettingsProvider>
);
